if (!customElements.get('combined-listing')) {
  customElements.define('combined-listing',
    class CombinedListing extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          this.updateSelectionMetadata(event);
        });

        this.updateSelectionMetadata({ target: this });
      }

      updateSelectionMetadata({ target }) {
        requestAnimationFrame(() => {
          const label = target.closest('label.offer__option');
          if (label) {
            const inputId = label.getAttribute('for');
            const input = document.getElementById(inputId);
            input.checked = true;
          }

          if (target.value !== undefined) this.syncVariantSelects(target);

          this.combinedListingInput = this.querySelectorAll('[data-combined-listing-input]');
          const checkedListingInput = Array.from(this.combinedListingInput).find(input => input.checked);
          this.finalListingValue = checkedListingInput.nextElementSibling.querySelector('.js-option-value-id').value;

          const variantListenerValue = this.closest('[id*="ProductInfo-"]').querySelector('[data-id-listener]').value;
          let variantId;
          this.finalListingValue == 'currentProduct' ? variantId = variantListenerValue : variantId = this.finalListingValue;

          let productBadges;
          this.finalListingValue == 'currentProduct' ? productBadges = true : productBadges = false;

          const individualDiscounts = this.closest('[id*="ProductInfo-"]').querySelectorAll('discount-copy[data-individual-only]');
          individualDiscounts.forEach(el => this.finalListingValue == 'currentProduct' ? el.classList.remove('visually-hidden') : el.classList.add('visually-hidden'));

          this.swiperSlider = this.closest('[data-swiper-general]').dataset.swiperGeneral;
          this.swiperSliderThumbs = this.closest('[data-swiper-general]').dataset.swiperThumbs;
          if (typeof filterSwiperSlides === 'function') filterSwiperSlides(`${variantId}`, window.sectionSwipers[this.swiperSlider], window.sectionSwipers[this.swiperSliderThumbs], productBadges);

          if (target.dataset.mediaSrc) {
            this.gallery = this.closest('[data-swiper-general]').querySelector('.product__slider-main').querySelectorAll('.product__media');

            this.gallery.forEach((media, index) => {
              if (media.dataset.srcAttached === target.dataset.mediaSrc) {
                window.sectionSwipers[this.swiperSlider].slideTo(index);
              }
            });
          }

          this.updateMainPrice(checkedListingInput);

          this.stickyATCInfo = document.querySelector('.product__sticky-atc-info');
          this.updateStickyATC(checkedListingInput);
        });
      }

      updateMainPrice(input) {
        const newPriceHTML = input.nextElementSibling?.querySelector('price-snippet .price')?.innerHTML;
        const productInfoPrice = this.closest('.product__info-wrapper')?.querySelector('.price__container div');
        if (newPriceHTML && productInfoPrice) {
          productInfoPrice.innerHTML = newPriceHTML;
        }
      }

      syncVariantSelects(target) {
        this.querySelectorAll('variant-selects').forEach((variantSelects) => {
          variantSelects.querySelectorAll('input').forEach((item) => {
            if (item.value === target.value) {
              item.checked = true;
              item.closest('.js-option-container').querySelector('.js-option-value-id').value = item.dataset.optionVariantId;

              const itemPriceElement = item.nextElementSibling?.querySelector('price-snippet [data-current-price]');
              const priceToChange = item.closest('.offer__option').querySelector('.option-info price-snippet .price');
              if (itemPriceElement && priceToChange) priceToChange.innerHTML = itemPriceElement.innerHTML;
            }
          });
        });
      }

      updateStickyATC(input) {
        if (!this.stickyATCInfo) return;

        const newTitle = input.nextElementSibling?.querySelector('[data-option-title]')?.innerHTML;
        const newPriceHTML = input.nextElementSibling?.querySelector('price-snippet .price')?.innerHTML;
        const newImage = input.nextElementSibling?.querySelector('.option-info img').src;

        const titleElement = this.stickyATCInfo.querySelector('.product__sticky-atc-heading');
        const priceElement = this.stickyATCInfo.querySelector('[data-current-price] .price__container div');
        const imageElement = this.stickyATCInfo.querySelector('img');

        if (titleElement && newTitle) titleElement.innerHTML = newTitle;
        if (priceElement && newPriceHTML) priceElement.innerHTML = newPriceHTML;
        if (imageElement && newImage) {
          imageElement.src = newImage;
          imageElement.srcset = newImage;
        }
      }
    }
  );
}